import { TextPropsTypes } from "../TextPropsTypes";
import "../SCSS/stylesMobile.css";
import { EnumSurveyAnswerStatus } from "../../../Common/Enums/EnumsTypes";

function TextBoxMobileView({
  questionId,
  surveyAnswers,
  isPreview,
  handleChangeInputSingleText,
  surveyAnswersInfo,
}: TextPropsTypes) {
  return (
    <div className="mobile-view-supplier-view-single-text-cover">
      <textarea
        disabled={
          isPreview ||
          surveyAnswersInfo?.surveyStatus === EnumSurveyAnswerStatus?.COMPLETED
        }
        className="single-text-area"
        placeholder=" Enter Answer"
        onChange={(e) =>
          surveyAnswersInfo?.surveyStatus !==
            EnumSurveyAnswerStatus?.COMPLETED &&
          handleChangeInputSingleText!(questionId, e)
        }
        value={surveyAnswers?.[questionId]?.val ?? ""}
      ></textarea>
    </div>
  );
}

export default TextBoxMobileView;
